import * as React from 'react';
import Seat from '@websky/core/src/SeatMap/components/SeatMap/Seat/Seat';
import { getSeatColor } from './getSeatColor';
const SeatMapSeat = React.memo(props => {
    return React.createElement(Seat, Object.assign({}, props, { className: getSeatColor(props.seat.rfisc) }));
});
export default SeatMapSeat;
